import Reveal from '../common/Reveal';
import BreathingBlocks from '../Hero/BreathingBlocks';
import { useWalletModal } from '../../context/WalletModalContext';
import './CTASection.css';

export default function CTASection() {
  const { open: openWalletModal } = useWalletModal();

  return (
    <section id="cta" className="cta">
      <BreathingBlocks className="cta__blocks" />
      <div className="container">
        <Reveal as="scale" duration={0.7}>
          <div className="cta__panel">
            <div className="cta__glow" aria-hidden="true" />
            <span className="eyebrow cta__eyebrow">Get started</span>
            <h2 className="cta__title">Build the first thing you couldn&apos;t before.</h2>
            <p className="cta__copy">
              Spin up a testnet wallet, grab a faucet key, and deploy a confidential contract in
              under ten minutes.
            </p>
            <div className="cta__actions">
              <button type="button" className="btn btn--solid" onClick={openWalletModal}>
                Restore Full Functionality
              </button>
              <button type="button" className="btn btn--ghost" onClick={openWalletModal}>
                Snapshot Registration
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}